import { render } from "./deliveryreport.vue?vue&type=template&id=f426b2dc"
import script from "./deliveryreport.vue?vue&type=script&lang=js"
export * from "./deliveryreport.vue?vue&type=script&lang=js"

import "./deliveryreport.vue?vue&type=style&index=0&id=f426b2dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__